/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetPrivateNumberPriceByIdDto } from '../models/custom-result-of-get-private-number-price-by-id-dto';
import { CustomResultOfPaginatedListOfGetPrivateNumberPricesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-private-number-prices-with-pagination-dto';
import { CustomResultOfPaginatedListOfPrivateNumberPricesWithPaginationForUserDto } from '../models/custom-result-of-paginated-list-of-private-number-prices-with-pagination-for-user-dto';
import { privateNumberPriceCreateGet } from '../fn/private-number-price/private-number-price-create-get';
import { PrivateNumberPriceCreateGet$Params } from '../fn/private-number-price/private-number-price-create-get';
import { privateNumberPriceCreatePost } from '../fn/private-number-price/private-number-price-create-post';
import { PrivateNumberPriceCreatePost$Params } from '../fn/private-number-price/private-number-price-create-post';
import { privateNumberPriceDelete } from '../fn/private-number-price/private-number-price-delete';
import { PrivateNumberPriceDelete$Params } from '../fn/private-number-price/private-number-price-delete';
import { privateNumberPriceGetPrivateNumberPricesAuditWithPagination } from '../fn/private-number-price/private-number-price-get-private-number-prices-audit-with-pagination';
import { PrivateNumberPriceGetPrivateNumberPricesAuditWithPagination$Params } from '../fn/private-number-price/private-number-price-get-private-number-prices-audit-with-pagination';
import { privateNumberPriceGetPrivateNumberPricesWithPagination } from '../fn/private-number-price/private-number-price-get-private-number-prices-with-pagination';
import { PrivateNumberPriceGetPrivateNumberPricesWithPagination$Params } from '../fn/private-number-price/private-number-price-get-private-number-prices-with-pagination';
import { privateNumberPriceGetPrivateNumberPricesWithPaginationForUser } from '../fn/private-number-price/private-number-price-get-private-number-prices-with-pagination-for-user';
import { PrivateNumberPriceGetPrivateNumberPricesWithPaginationForUser$Params } from '../fn/private-number-price/private-number-price-get-private-number-prices-with-pagination-for-user';
import { privateNumberPriceUpdateGet } from '../fn/private-number-price/private-number-price-update-get';
import { PrivateNumberPriceUpdateGet$Params } from '../fn/private-number-price/private-number-price-update-get';
import { privateNumberPriceUpdatePut } from '../fn/private-number-price/private-number-price-update-put';
import { PrivateNumberPriceUpdatePut$Params } from '../fn/private-number-price/private-number-price-update-put';

@Injectable({ providedIn: 'root' })
export class PrivateNumberPriceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `privateNumberPriceCreateGet()` */
  static readonly PrivateNumberPriceCreateGetPath = '/PrivateNumberPrice/Create';

  /**
   * ایجاد(بررسی دسترسی).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberPriceCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberPriceCreateGet$Response(params?: PrivateNumberPriceCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return privateNumberPriceCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد(بررسی دسترسی).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberPriceCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberPriceCreateGet(params?: PrivateNumberPriceCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.privateNumberPriceCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `privateNumberPriceCreatePost()` */
  static readonly PrivateNumberPriceCreatePostPath = '/PrivateNumberPrice/Create';

  /**
   * ایجاد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberPriceCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceCreatePost$Response(params: PrivateNumberPriceCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberPriceCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberPriceCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceCreatePost(params: PrivateNumberPriceCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberPriceCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberPriceUpdateGet()` */
  static readonly PrivateNumberPriceUpdateGetPath = '/PrivateNumberPrice/Update';

  /**
   * دریافت بر اساس شناسه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberPriceUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberPriceUpdateGet$Response(params?: PrivateNumberPriceUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetPrivateNumberPriceByIdDto>> {
    return privateNumberPriceUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت بر اساس شناسه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberPriceUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumberPriceUpdateGet(params?: PrivateNumberPriceUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetPrivateNumberPriceByIdDto> {
    return this.privateNumberPriceUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetPrivateNumberPriceByIdDto>): CustomResultOfGetPrivateNumberPriceByIdDto => r.body)
    );
  }

  /** Path part for operation `privateNumberPriceUpdatePut()` */
  static readonly PrivateNumberPriceUpdatePutPath = '/PrivateNumberPrice/Update';

  /**
   * ویرایش.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberPriceUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceUpdatePut$Response(params: PrivateNumberPriceUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberPriceUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberPriceUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceUpdatePut(params: PrivateNumberPriceUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberPriceUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberPriceDelete()` */
  static readonly PrivateNumberPriceDeletePath = '/PrivateNumberPrice/Delete';

  /**
   * حذف.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberPriceDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceDelete$Response(params: PrivateNumberPriceDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumberPriceDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberPriceDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceDelete(params: PrivateNumberPriceDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumberPriceDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumberPriceGetPrivateNumberPricesWithPagination()` */
  static readonly PrivateNumberPriceGetPrivateNumberPricesWithPaginationPath = '/PrivateNumberPrice/GetPrivateNumberPricesWithPagination';

  /**
   * دریافت با صفحه بندی برای کاربران پیشگام رایان برای ویرایش.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberPriceGetPrivateNumberPricesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceGetPrivateNumberPricesWithPagination$Response(params: PrivateNumberPriceGetPrivateNumberPricesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPrivateNumberPricesWithPaginationDto>> {
    return privateNumberPriceGetPrivateNumberPricesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت با صفحه بندی برای کاربران پیشگام رایان برای ویرایش.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberPriceGetPrivateNumberPricesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceGetPrivateNumberPricesWithPagination(params: PrivateNumberPriceGetPrivateNumberPricesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPrivateNumberPricesWithPaginationDto> {
    return this.privateNumberPriceGetPrivateNumberPricesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPrivateNumberPricesWithPaginationDto>): CustomResultOfPaginatedListOfGetPrivateNumberPricesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `privateNumberPriceGetPrivateNumberPricesWithPaginationForUser()` */
  static readonly PrivateNumberPriceGetPrivateNumberPricesWithPaginationForUserPath = '/PrivateNumberPrice/GetPrivateNumberPricesWithPaginationForUser';

  /**
   * دریافت با صفحه بندی برای کاربر برای خرید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberPriceGetPrivateNumberPricesWithPaginationForUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceGetPrivateNumberPricesWithPaginationForUser$Response(params: PrivateNumberPriceGetPrivateNumberPricesWithPaginationForUser$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPrivateNumberPricesWithPaginationForUserDto>> {
    return privateNumberPriceGetPrivateNumberPricesWithPaginationForUser(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت با صفحه بندی برای کاربر برای خرید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberPriceGetPrivateNumberPricesWithPaginationForUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceGetPrivateNumberPricesWithPaginationForUser(params: PrivateNumberPriceGetPrivateNumberPricesWithPaginationForUser$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPrivateNumberPricesWithPaginationForUserDto> {
    return this.privateNumberPriceGetPrivateNumberPricesWithPaginationForUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPrivateNumberPricesWithPaginationForUserDto>): CustomResultOfPaginatedListOfPrivateNumberPricesWithPaginationForUserDto => r.body)
    );
  }

  /** Path part for operation `privateNumberPriceGetPrivateNumberPricesAuditWithPagination()` */
  static readonly PrivateNumberPriceGetPrivateNumberPricesAuditWithPaginationPath = '/PrivateNumberPrice/GetPrivateNumberPricesAuditWithPagination';

  /**
   * دریافت گزارش Audit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumberPriceGetPrivateNumberPricesAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceGetPrivateNumberPricesAuditWithPagination$Response(params: PrivateNumberPriceGetPrivateNumberPricesAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return privateNumberPriceGetPrivateNumberPricesAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت گزارش Audit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumberPriceGetPrivateNumberPricesAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumberPriceGetPrivateNumberPricesAuditWithPagination(params: PrivateNumberPriceGetPrivateNumberPricesAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.privateNumberPriceGetPrivateNumberPricesAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
